export default __webpack_public_path__ + "static/fonts/TiemposHeadline-Light.341c01b.woff2";